import { usePricingPackagesByListingQuery } from "~graphql/generated/graphql"

export default function usePricingPackagesByListing({
    listingId = "",
    dates,
    numberOfGuests,
}: {
    listingId?: string
    dates?: number[]
    numberOfGuests?: number
}) {
    const {
        data,
        loading: isLoading,
        error,
    } = usePricingPackagesByListingQuery({
        variables: { listingId, dates: dates, numberOfGuests },
        skip: !listingId,
        fetchPolicy: "network-only",
    })
    const pricingPackages = data?.pricingPackagesByListing ?? []

    return { pricingPackages, isLoading, error }
}
